import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default function initTimelineCompare() {
  document.querySelectorAll("[data-tc-block]").forEach(block => {
    const rows = Array.from(block.querySelectorAll("[data-tc-row]"));

    const rightEdgePx = (barEl, targetEl) => {
      const br = barEl.getBoundingClientRect();
      const tr = targetEl.getBoundingClientRect();
      return Math.max(0, tr.right - br.left);
    };

    // Collect row data
    const data = rows.map((row, i) => {
      const bar    = row.querySelector("[data-tc-bar]");
      const target = row.querySelector(".tc-left-target");
      return { row, bar, target, i, filled: false };
    }).filter(d => d.bar && d.target);

    if (!data.length) return;

    // Start with no fill so the entrance animation is visible
    data.forEach(d => gsap.set(d.bar, { "--fill": "0px" }));

    // Animate to each row's target width when the block enters view
    let played = false;
    ScrollTrigger.create({
      trigger: block,
      start: "top 80%",
      once: true,
      onEnter: () => {
        if (played) return;
        played = true;

        const tl = gsap.timeline({ defaults: { ease: "power2.out", duration: 0.9 } });

        data.forEach((d, idx) => {
          const fill = rightEdgePx(d.bar, d.target);
          tl.to(d.bar, { "--fill": fill + "px" }, idx * 0.12);
        });

        // Make first row appear "active" (purple + body)
        tl.add(() => {
          const first = data[0]?.row;
          if (first) first.classList.add("is-primed");
        }, 0);
      }
    });

    // Hover behavior (purple overlay + body reveal)
    data.forEach((d) => {
      const { row, bar, target } = d;

      row.addEventListener("mouseenter", () => {
        // remove initial primed from another row
        const primed = row.parentElement.querySelector(".tc-row.is-primed");
        if (primed && primed !== row) primed.classList.remove("is-primed");

        row.classList.add("is-hovered");

        // Re-measure in case layout changed (fonts/images/resizes)
        const fill = rightEdgePx(bar, target);
        gsap.to(bar, { duration: 0.25, ease: "power2.out", "--fill": fill + "px" });
      });

      row.addEventListener("mouseleave", () => {
        row.classList.remove("is-hovered");
        // leave the gray width as-is
      });

      // Keep aligned on resize for active rows
      const resizeRecalc = () => {
        if (row.classList.contains("is-hovered") || row.classList.contains("is-primed")) {
          const fill = rightEdgePx(bar, target);
          gsap.set(bar, { "--fill": fill + "px" });
        }
      };
      window.addEventListener("resize", resizeRecalc);
    });
  });

  document.querySelectorAll("[data-tc-block]").forEach(block => {
  const acc   = block.querySelector(".tc-m-accordion[data-one-open]");
  const cols  = block.querySelectorAll(".tc-m-col");
  if (!acc || !cols.length) return;

  const details = acc.querySelectorAll("details");

  const HEADER_OFFSET = 77;
  const EXTRA_PADDING = 12;

  const scrollToDetails = (idx) => {
    const target = details[idx];
    if (!target) return;

    const rect = target.getBoundingClientRect();
    const targetY = window.pageYOffset + rect.top - HEADER_OFFSET - EXTRA_PADDING;

    window.scrollTo({
      top: targetY,
      behavior: "smooth",
    });
  };

  const setActive = (idx, scroll = false) => {
    cols.forEach((c, i) => c.classList.toggle("is-active", i === idx));
    details.forEach((d, i) => {
      if (i === idx) d.setAttribute("open", "");
      else d.removeAttribute("open");
    });

    if (scroll) {
      scrollToDetails(idx);
    }
  };


  let initIdx = Array.from(details).findIndex(d => d.hasAttribute("open"));
  if (initIdx < 0) {
    const activeCol = block.querySelector(".tc-m-col.is-active");
    initIdx = activeCol ? parseInt(activeCol.getAttribute("data-index"), 10) : 0;
    details[initIdx]?.setAttribute("open", "");
  }
  setActive(initIdx, false);

  cols.forEach(col => {
    const idx = parseInt(col.getAttribute("data-index"), 10);
    col.addEventListener("click", () => setActive(idx, true));
  });

  details.forEach(d => {
    const idx = parseInt(d.getAttribute("data-index"), 10);
    d.addEventListener("toggle", () => {
      if (d.open) {
        // open this, close others, highlight matching column
        details.forEach(o => { if (o !== d) o.removeAttribute("open"); });
        cols.forEach((c, i) => c.classList.toggle("is-active", i === idx));
      } else {
        // if user closed the currently open item and NONE are open, clear highlights
        const anyOpen = Array.from(details).some(x => x.open);
        if (!anyOpen) cols.forEach(c => c.classList.remove("is-active"));
      }
    });
  });
  });
}
